import React from 'react';

const Experience = () => {
  const experiences = [
    {
      position: 'Senior Software Engineer',
      company: 'Freelancer.',
      duration: '2022 - Present',
      description: 'Leading frontend development team, architecting scalable web applications using React, TypeScript, and modern development practices.',
      responsibilities: [
        'Developed and maintained 15+ production applications',
        'Mentored junior developers and conducted code reviews',
        'Improved application performance by 40%',
        'Implemented CI/CD pipelines and automated testing'
      ]
    },
    {
      position: 'Full Stack Developer',
      company: 'Digital Innovations Ltd.',
      duration: '2020 - 2022',
      description: 'Developed full-stack web applications using MERN stack, collaborated with cross-functional teams to deliver high-quality solutions.',
      responsibilities: [
        'Built RESTful APIs and integrated third-party services',
        'Designed and implemented database schemas',
        'Collaborated with UI/UX designers for pixel-perfect implementations',
        'Optimized application performance and security'
      ]
    },
    {
      position: 'Frontend Developer',
      company: 'Creative Web Studio',
      duration: '2018 - 2020',
      description: 'Created responsive and interactive user interfaces, worked closely with designers to bring concepts to life.',
      responsibilities: [
        'Developed responsive websites using HTML, CSS, JavaScript',
        'Implemented modern frontend frameworks and libraries',
        'Ensured cross-browser compatibility and accessibility',
        'Collaborated with backend team for API integration'
      ]
    }
  ];

  return (
    <section className="experience-section" id="experience">
      <div className="section-header" data-aos="fade-up">
        <h2 className="section-title">Work Experience</h2>
        <p className="section-subtitle">
          My professional journey and key achievements in software development
        </p>
      </div>

      <div className="experience-timeline">
        {experiences.map((exp, index) => (
          <div 
            key={index} 
            className="experience-card" 
            data-aos="fade-up" 
            data-aos-delay={index * 100}
          >
            <div className="experience-header">
              <div className="experience-title-group">
                <h3 className="experience-position">{exp.position}</h3>
                <p className="experience-company">
                  <i className="ph ph-buildings"></i>
                  {exp.company}
                </p>
              </div>
              <div className="experience-duration">
                <i className="ph ph-calendar"></i>
                {exp.duration}
              </div>
            </div>
            <p className="experience-description">{exp.description}</p>
            <ul className="experience-responsibilities">
              {exp.responsibilities.map((responsibility, idx) => (
                <li key={idx}>
                  <i className="ph ph-check-circle"></i>
                  {responsibility}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Experience;
